[
    {
        "id": "Info",
        "title": "Forum Info & Introductions ",
        "description": "The very first board, where all the best discussions happen."
    },
    {
        "id": "general",
        "title": "General Interests",
        "description": "A board for normal stuff. "
    },
    {
        "id": "phenomena",
        "title": "Unexplained Phenomena and Supernatural",
        "description": "For creepies, crawlies, cases, curiosities, and cryptozoological oCuurences "
    },
    {
        "id": "accounts",
        "title": "First Hand Accounts ",
        "description": "Did you experience something? Tell us about it! Not for stories about hands. "
    },
    {
        "id": "news",
        "title": "News and Stories ",
        "description": "Clippings and collections of happenings around the tri-state area "
    },
    {
        "id": "theories",
        "title": "Theory Crafting ",
        "description": "Bounce ideas and theories off other brainiacs "
    }
]